import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { getMenuAccessForUser } from '@/services/menu_access.service'
import { getFallbackMenuKeys, menuKeysToItems } from '@/constants/menu_catalog'

export default createStore({
  state: {
    users: {
      username: null,
      firstname: null,
      lastname: null,
      email: null,
      status: null,
      role: null,
      plantNo: null,
      token: null,
      mustChangePassword: false,
    },
    authenticated: false,
    menus: [],
  },
  getters: {
    isAuthenticated: state => state.authenticated || !!state.users.token,
    role: state => state.users.role,
    accessMenus: state => state.menus,
    username: state => state.users.username,
    email: state => state.users.email,
    plantno: state => state.users.plantNo,
    token: state => state.users.token,
    mustChangePassword: state => state.users.mustChangePassword,
  },
  mutations: {
    setUserSession(state, user) {
      state.users = user
      state.authenticated = !!(state.users.username && state.users.role)
      localStorage.setItem('username', user.username)
      localStorage.setItem('token', user.token)
    },
    setMenus(state, menus) {
      state.menus = Array.isArray(menus) ? menus : []
    },
    clearSession(state) {
      state.users = {
        username: null,
        firstname: null,
        lastname: null,
        email: null,
        status: null,
        role: null,
        plantNo: null,
        token: null,
        mustChangePassword: false,
      }
      state.authenticated = false
      state.menus = []
      localStorage.removeItem('username')
      localStorage.removeItem('token')
    },
    setMustChangePassword(state, value) {
      if (state.users) {
        state.users.mustChangePassword = !!value
      }
    },
  },
  actions: {
    async login({ commit, dispatch }, data) {
      commit('setUserSession', data)
      await dispatch('loadMenus')
    },
    async loadMenus({ commit, state }) {
      const role = state.users.role
      const plantNo = state.users.plantNo
      if (!role) {
        commit('setMenus', [])
        return
      }
      try {
        const { data } = await getMenuAccessForUser()
        const keys = Array.isArray(data) ? data : []
        commit('setMenus', menuKeysToItems(keys))
      } catch (err) {
        console.warn('loadMenus: API failed, using fallback catalog', err)
        const fallbackKeys = getFallbackMenuKeys(role, plantNo)
        commit('setMenus', menuKeysToItems(fallbackKeys))
      }
    },
    logout({ commit }) {
      commit('clearSession')
    },
    clearMustChangePassword({ commit }) {
      commit('setMustChangePassword', false)
    },
  },
  modules: {},
  plugins: [createPersistedState()],
})
